import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const ListaTP = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista1" id="miLista1" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Producto</option>
        <option>Servicio</option>
        <option>Programa</option>
      </select>
    </div>
  )
};

const ListaTO = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista3" id="miLista3" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Laboratorio</option>
        <option>In house</option>
        <option>Despacho</option>
        <option>Otros</option>
      </select>
    </div>
  )
};

const DetalleNivel2 = props => {
  return (
    <option dato1={props.elemento.abrevUnidad} value={props.elemento._id}>{props.elemento.descrUnidad}</option>

  )
};

const ListaUni = ({list, handleLista1}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrUnidad" id="miLista8" onChange={handleLista1}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleNivel3 = props => {
  return (
    <option value={props.elemento._id}>{props.elemento.descrLubricante}</option>

  )
};

const ListaLub = ({list, handleLista1}) => {
  const Nivel3Detalle = list.map((elemento, _id) => <DetalleNivel3 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrLubricante" id="miLista2" onChange={handleLista1}>
        <option value="">NINGUNO</option>
        {Nivel3Detalle}
      </select>
    </div>
  )
};

const ListaMon = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="monedaCosto" id="miLista55" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Pesos</option>
        <option>Dolares</option>
        <option>Euros</option>
      </select>
    </div>
  )
};

class AddProducto2 extends React.Component{
  state={argsAdd: {}, vigenteHasta: this.props.fechaHasta} 

  handleChange = async (ev) => {
    const argsAdd = this.state.argsAdd
    let file = "", ficha = "", file1 = "", ficha2 = ""
    if(ev.target.name==='file' || ev.target.name==='file1'){
      if(ev.target.name==='file'){
        file = ev.target.files[0]
        ficha = ev.target.files[0].name
        argsAdd['ficha'] = ficha
        argsAdd['file'] = file      
      }
      if(ev.target.name==='file1'){
        file1 = ev.target.files[0]
        ficha2 = ev.target.files[0].name
        argsAdd['ficha2'] = ficha2
        argsAdd['file1'] = file1      
      }
    }else{
      if(ev.target.name==='vigenteHasta'){
        argsAdd[ev.target.name] = ev.target.value
        this.setState({vigenteHasta: argsAdd.vigenteHasta})
        console.log(argsAdd, this.state)
      }else{
        argsAdd[ev.target.name] = ev.target.value
      }
    }
    argsAdd['ficha'] = ficha
    argsAdd['file'] = file
    argsAdd['ficha2'] = ficha2
    argsAdd['file1'] = file1
    this.setState({argsAdd})
  }


render(){
  const {argsAdd} = this.state;
  let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
  let args = Object.assign({}, this.props.args, argsAdd)

console.log(args)

  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Producto nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args)}>
          <div className="ui eight column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Tipo de producto</label>
                  <ListaTP styles={this.props.styles} handleLista={this.props.handleLista} />
                </Form.Field>
              </div>
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Tipo de orden</label>
                  <ListaTO styles={this.props.styles} handleLista={this.props.handleLista3} />
                </Form.Field>
              </div>
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Marca</label>
                  <Form.Input autoComplete="off" name="marca" id="marca" onChange={this.handleChange} placeholder='Marca' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'marca'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field> 
              </div>
              <div className="column" style={{width: '25%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrProducto" id="descrProducto" onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrProducto'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field> 
              </div>
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Código</label>
                  <Form.Input autoComplete="off" name="codigo" id="codigo" onChange={this.handleChange} placeholder='Código' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field> 
              </div>
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Costo</label>
                  <input type='number' step="0.01" min="0" autoComplete="off" name="costo" id="costo" placeholder='Costo' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" width="15%">                
                <Form.Field>
                  <label style={this.props.styles.label}>Moneda costo</label>
                  <ListaMon styles={this.props.styles} handleLista={this.props.handleLista55} />
                </Form.Field>
              </div>
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>% Utilidad</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="margen" id="margen" placeholder='% Utilidad' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
            </div>
            <div className="row container">
              {/* {args.tipoProducto!=='Producto' && */}
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Precio Und $</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="precio" id="precio" placeholder='Valor Und en $' onChange={this.props.handleChange}/>
                  </Form.Field> 
                </div>
              {/* } */}
              {/* {args.tipoProducto!=='Producto' && */}
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Precio Und $US</label>
                    <input type='number' step="0.01" min="0" autoComplete="off" name="precioDolar" id="precioDolar" placeholder='Valor Und en $US' onChange={this.props.handleChange}/>
                  </Form.Field> 
                </div>
              {/* } */}
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Vigencia de precio</label>
                  <input style={this.props.styles.input} type='date' name="vigenteHasta" id="vigenteHasta" value={this.state.vigenteHasta} onChange={this.handleChange}/>
                </Form.Field>
              </div>
              <div className="column" style={{width: '10%'}}>                
                <Form.Field>
                  <label style={this.props.styles.label}>Unidad</label>
                  <ListaUni list={this.props.listUni} handleLista1={this.props.handleLista1} />
                </Form.Field>    
              </div>
              <div className="column" style={{width: '8%'}}> 
                <Form.Field>
                  <label style={this.props.styles.label}>% IVA</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="porcIVA" id="porcIVA" placeholder='% IVA' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" style={{width: '8%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>% ITBMS</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="porcImpto" id="porcImpto" placeholder='% ITBMS' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" style={{width: '44%'}}>                
                <Form.Field>
                  <label style={this.props.styles.label}>Lubricante asociado</label>
                  <ListaLub list={this.props.listLub} handleLista1={this.props.handleLista2} />
                </Form.Field>    
              </div>
            </div>
          </div>
          <div className="ui two column stackable grid">
            <div className="row container">  
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Comisión rango 1</label>
                  <input type='number' step="0.01" min="0" autoComplete="off" name="comisionRango1" id="comisionRango1" placeholder='Comisión rango 1' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Comisión rango 2</label>
                  <input type='number' step="0.01" min="0" autoComplete="off" name="comisionRango2" id="comisionRango2" placeholder='Comisión rango 2' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Comisión rango 3</label>
                  <input type='number' step="0.01" min="0" autoComplete="off" name="comisionRango3" id="comisionRango3" placeholder='Comisión rango 3' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" style={{width: '10%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Comisión externos</label>
                  <input type='number' step="0.01" min="0" autoComplete="off" name="comisionExt" id="comisionExt" placeholder='Comisión externo' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" style={{width: '29%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Descripción corta</label>
                  <Form.Input autoComplete="off" name="descrCorta" id="descrCorta" onChange={this.handleChange} placeholder='Descripción corta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrCorta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field> 
              </div>
            </div>
          </div>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" width="50%">
                <Form.Field>
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Seleccionar archivo de ficha técnica...&nbsp;&nbsp;
                  </label>
                  <input id="file" name="file" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={this.handleChange}></input>
                </Form.Field>  
              </div>
              <div className="column" width="50%">
                <Form.Field>
                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Seleccionar archivo de ficha de seguridad...&nbsp;&nbsp;
                  </label>
                  <input id="file1" name="file1" type="file" accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" multiple={false} style={estilos} onChange={this.handleChange}></input>
                </Form.Field>  
              </div>
            </div>
          </div>
          <Button style={this.props.styles.confirmar} type='submit' fluid>
            AGREGAR
          </Button>

          {
            this.props.errors.length?<Message negative header="Los siguientes errores:"
            list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
          }
              
            
        </Form>
      </div>
    </div>
  )
}
}

export default AddProducto2
